import { Container, CloseButton } from "./styles";
import CheckIcon from "icons/CheckIcon";
import ErrorIcon from "icons/ErrorIcon";
import CrossIcon from "icons/CrossIcon";

const icons = {
    "success": <CheckIcon color="var(--light-1)"/>,
    "error": <ErrorIcon color="var(--light-1)"/>
};
export const TIMEOUT_HIDDEN_TOAST_MESSAGE = 2500;

const ToastMessage = ({
    message = "Éxito", 
    variant = "success",
    hidden = false, 
    toggleHidden
}) => {
    const getClassName = () => {
        const classList = [];
        hidden && classList.push("hidden");
        classList.push(variant);
        return classList.join(" ");
    }
    return (
        <Container className={getClassName()}>
            {icons[variant] || null}
            <h6>{message}</h6>
            {toggleHidden && 
            <CloseButton onClick={toggleHidden}>
                <CrossIcon/>
            </CloseButton>}
        </Container>
    );
}

export default ToastMessage;